import React, { useState, useRef, useEffect } from "react"

import { TextField, Box, List, ListItemButton, ListSubheader, IconButton, Tooltip } from '@mui/material'

import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

import { getSession } from '../../../auth'
import api from '../../../api'

import './styles.css'

const CustomWidthTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} placement="top" />
))({
    [`& .${tooltipClasses.tooltip}`]: {
        maxWidth: 200,
    },
});

const CLIENT_VARIABLES = {
    'Nome do contato'            : 'nome_cliente',
    'Primeiro nome do contato'   : 'nome_cliente_resumido',
    'Telefone'                   : 'telefone_cliente',
    'E-mail'                     : 'email_cliente',
    'Nome da empresa'            : 'empresa_cliente',
    'CPF/CNPJ'                   : 'cpf_cnpj_cliente',
    'Aniversário'                : 'aniversario_cliente',
    'ID do contato'              : 'id_cliente',
}

const OPPORTUNITY_VARIABLES = {
    'Título da oportunidade'       : 'titulo_oportunidade',
    'Descrição da oportunidade'   : 'descricao_oportunidade',
    'Valor da oportunidade'      : 'valor_oportunidade',
    'Nome do Vendedor'             : 'nome_vendedor_oportunidade',
    'Data de fechamento'        : 'data_fechamento_oportunidade',
    'ID da oportunidade'        : 'id_oportunidade',
    'Nome da Empresa'            : 'empresa_oportunidade',
    'Nome do Contato'            : 'contato_oportunidade',
    'Outros contatos'                : 'outros_contatos_oportunidade',
}

const Dropdown = ({ onVariableSelect, opportunityCustomFields = null, index = '' }) => {


    const dropref = useRef()
    const buttonref = useRef()
 
    const [showOptions, setShowOptions] = useState(false)
    const [customFields, setCustomFields] = useState([])

    const setTarget = (variable, index = ' ') => target(variable, index)

    function getAbsPosition(element) {
        var rect = element.getBoundingClientRect();
        return { x: rect.left, y: rect.top }
    }

    const moveDiv = () => {
        const selectedDiv = dropref?.current
        const selectedButton = buttonref?.current

        const coords = getAbsPosition(selectedButton);

        const posX = coords.x - selectedDiv.clientWidth
        const posY = coords.y

        selectedDiv.style.left = `${posX}px`
        selectedDiv.style.top = `${posY}px`

        setShowOptions(true)
    }

    useEffect(() => {
        api.get(`api/enterprises/${getSession().profile.enterprise.id}/custom_fields/`)
            .then((res) => {
                if (res.status === 200)
                    setCustomFields(res.data)
            })
    }, [])

    return (
        <>
            <CustomWidthTooltip title='Selecione uma variável'>
                <IconButton ref={buttonref} className='absolute-button' onClick={e => { e.preventDefault(); moveDiv();  }}>
                    <KeyboardArrowDownIcon />
                </IconButton>
            </CustomWidthTooltip>
            <Box className={`select-pop-up-backdrop ${showOptions ? 'active': ''}`} onClick={() => setShowOptions(false)}></Box>
            <Box ref={dropref} className={`select-pop-up ${showOptions ? 'active': ''}`}>
                <List className='select-list insiderlist'>
                    <ListSubheader>Geral</ListSubheader>
                    <ListItemButton
                        className='select-list-item'
                        onClick={() => onVariableSelect('{{data_envio}}')}
                    >
                        Data do envio
                    </ListItemButton>
                    <ListSubheader>Operador</ListSubheader>
                    <ListItemButton
                        className='select-list-item'
                        onClick={() => onVariableSelect('{{nome_operador}}')}
                    >
                        Nome do operador
                    </ListItemButton>
                    <ListSubheader>Contato</ListSubheader>
                    {Object.entries(CLIENT_VARIABLES).map(([key, value]) => (
                        <ListItemButton
                            key={`client-variable-${key}`}
                            className='select-list-item'
                            onClick={() => onVariableSelect(`{{${value}}}`)}
                        >
                            {key}
                        </ListItemButton>
                    ))}
                    {customFields.map((field) => (
                        <ListItemButton
                            key={`client-variable-${field.field_name}`}
                            className='select-list-item'
                            onClick={() => onVariableSelect(`{{custom_${field.id}_cliente}}`)}
                        >
                            {field.field_name}
                        </ListItemButton>
                    ))}
                    {Array.isArray(opportunityCustomFields) && (
                        <>
                            <ListSubheader>Oportunidade</ListSubheader>
                            {Object.entries(OPPORTUNITY_VARIABLES).map(([key, value]) => (
                                <ListItemButton
                                    key={`opportunity-variable-${key}`}
                                    className='select-list-item'
                                    onClick={() => onVariableSelect(`{{${value}}}`)}
                                >
                                    {key}
                                </ListItemButton>
                            ))}
                            {opportunityCustomFields.map((field) => (
                                <ListItemButton
                                    key={`opportunity-variable-custom-${field.id}`}
                                    className='select-list-item'
                                    onClick={() => onVariableSelect(`{{custom_${field.id}_oportunidade}}`)}
                                >
                                    {field.name}
                                </ListItemButton>
                            ))}
                        </>
                    )}
                </List>
            </Box>
        </>
    )
}

const VariableTextField = ({ sx, size, label, value, variant, multiline, fullWidth, onChange, onVariableSelect, key, opportunityCustomFields = null, ...args }) => {

    return (
        <Box className="relative-box">
            <TextField
                {...args}
                sx={sx}
                fullWidth={fullWidth}
                multiline={multiline}
                size={size}
                label={label}
                type="text"
                variant={variant}
                value={value}
                onChange={onChange}
                key={key}
            />
            <Dropdown onVariableSelect={onVariableSelect} opportunityCustomFields={opportunityCustomFields} />
        </Box>
    )
}

export default VariableTextField
